
export const itemsData = [
  {
    id: 1,
    type: "education",
    title: "Perito en computación",
    issuer: "Fundación Kinal",
    date: "2023 - 2025",
    image: "https://siemprehaciaadelanteguate.com/wp-content/uploads/2021/09/fundacion-kinal-2048x739.png",
    description: "Focused on full stack software development. Includes Networking, Java, SQL, JavaScript, HTML, CSS, React.",
    featured: true,
  },
  {
    id: 2,
    type: "certificate",
    topic: "Computer Science",
    title: "CS50 Introduction to Computer Science",
    issuer: "Harvard University",
    date: "2025",
    image: "https://logodownload.org/wp-content/uploads/2021/04/harvard-university-logo-1.png",
    link: "https://certificates.cs50.io/33b85a31-3a8e-4948-9930-59b516591112.pdf?size=letter",
    featured: true,
  },
  {
    id: 3,
    type: "certificate",
    topic:"Cybersecurity",
    title: "Blue Team Junior Analyst Pathway",
    issuer: "Security Blue Team",
    date: "2025",
    image: "https://wp.securityblue.team/wp-content/uploads/2020/11/sbtwhitebg-600x445-1-300x223.png",
    link: "https://drive.google.com/file/d/1_5bE4_eqBlRNf_N5Ef5otbg7rB6uHUYV/view",
    featured: true,
  },
  {
    id: 4,
    type: "certificate",
    topic: "Cibersecurity",
    title: "Introduction to OSINT",
    issuer: "Security Blue Team",
    date: "2025",
    image: "https://wp.securityblue.team/wp-content/uploads/2020/11/sbtwhitebg-600x445-1-300x223.png",
    link: "https://drive.google.com/file/d/1Q55fEsJ4_PDz1cz1m-5VHikstPb0Um0I/view",
    featured: false,
  },
  {
    id: 5,
    type: "certificate",
    topic: "Linux",
    title: "Introduction to Linux",
    issuer: "The Linux Foundation",
    date: "2025",
    image: "https://bootflare.com/wp-content/uploads/2023/02/The-Linux-Foundation.png",
    link: "https://ti-user-certificates.s3.amazonaws.com/e0df7fbf-a057-42af-8a1f-590912be5460/73ffe365-001d-4eb4-a58e-bb6f5af87e24-luis-len-c46b13dd-37ca-492e-8a6c-87be141463c5-certificate.pdf",
    featured: false,
  },
  {
    id: 6,
    type: "certificate",
    topic: "AI",
    title: "AI For Productivity",
    issuer: "Google",
    date: "2025",
    image: "https://1000logos.net/wp-content/uploads/2021/05/Google-logo.png",
    link: "https://drive.google.com/file/d/1kWYPxMKTCdPf2F88ktX8hbapKAbafRwv/view",
    featured: false,
  },
    {
    id: 7,
    type: "certificate",
    topic: "Scrum",
    title: "Registered Scrum Basics",
    issuer: "Scrum Inc",
    date: "2025",
    image: "https://agileeducation.org/wp-content/uploads/2021/09/AEP_Logo_1800-1.png",
    link: "https://s3.amazonaws.com/scruminc-certs/RSB-8217106",
    featured: false,
  },
  
];